import React from 'react';
import ListingPage from './component';

export default React.memo(ListingPage);
